import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import CusButton from '../CusButton';
import styles from './GarenaLogin.module.scss';
import { dispatchPostError } from '~/redux/reducer/error';
import { requestPlayerLoginGarena } from '~/services/auth';
import { loginAccountSuccess, logoutAccountSuccess } from '~/redux/reducer/auth';

const cx = classNames.bind(styles);

function GarenaLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [loading, setLoading] = useState(false);
    const [usernameError, setUsernameError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [messageErrorLogin, setMessageErrorLogin] = useState('');

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const ref = queryParams.get('ref');

    const { code } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.auth);

    // Tự động focus vào input username khi trang load
    useEffect(() => {
        document.getElementById('username')?.focus();
    }, []);

    useEffect(() => {
        if (currentUser) {
            if (ref && ref === 'billing') {
                navigate(`/billing/${currentUser.app.code}`);
            } else {
                navigate(`/app/${currentUser.app.code}`);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser]);

    const handleRegisterAccount = () => {
        window.open('https://sso.garena.com/universal/register', '_blank');
    };

    // Hàm kiểm tra dữ liệu đầu vào cho username và password
    const handleBlurInput = (type) => {
        if (type === 'username') {
            if (!username) {
                setUsernameError(true);
            } else {
                setUsernameError(false);
            }
        }
        if (type === 'password') {
            if (!password) {
                setPasswordError(true);
            } else {
                setPasswordError(false);
            }
        }
    };

    const handleLoginAccountGarena = async () => {
        const data = {
            username,
            password,
            app_id: code,
        };

        setLoading(true);
        setMessageErrorLogin('');

        const result = await requestPlayerLoginGarena(data);

        setLoading(false);
        if (result.status === 403) {
            dispatch(logoutAccountSuccess());
            localStorage.removeItem('_re');
            navigate('/');
            window.location.reload();
        } else if (result.status === 401) {
            dispatch(dispatchPostError(result));
        } else if (result.status === 200) {
            dispatch(loginAccountSuccess(result.data));

            if (ref && ref === 'billing') {
                navigate(`/billing/${result.data.app.code}`);
            } else {
                navigate(`/app/${result.data.app.code}`);
            }
        } else {
            setMessageErrorLogin(result.error);
        }
    };

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <h2 className={cx('title')}>Đăng nhập</h2>

                <div className={cx('field', 'required', { error: usernameError })}>
                    <input
                        id="username"
                        className={cx('input')}
                        type="text"
                        placeholder="Tài khoản Garena, Email hoặc số điện thoại"
                        value={username}
                        onChange={(e) => {
                            setUsernameError(false);
                            setUsername(e.target.value);
                        }}
                        onBlur={() => handleBlurInput('username')}
                    />

                    {usernameError && <div className={cx('message')}>Nhập tên tài khoản hoặc email hợp lệ</div>}
                </div>

                <div className={cx('field', 'required', { error: passwordError })}>
                    <input
                        id="password"
                        className={cx('input')}
                        type="password"
                        placeholder="Mật khẩu"
                        value={password}
                        onChange={(e) => {
                            setPasswordError(false);
                            setPassword(e.target.value);
                        }}
                        onBlur={() => handleBlurInput('password')}
                    />

                    {passwordError && <div className={cx('message')}>Nhập mật khẩu hợp lệ</div>}
                </div>

                <a href="https://account.garena.com/recovery#/" className={cx('forgot')} target="_blank" rel="noreferrer">
                    Quên mật khẩu?
                </a>

                <div className={cx('field', { error: messageErrorLogin })}>
                    <CusButton
                        text={loading ? 'Đang đăng nhập...' : 'Đăng Nhập Ngay'}
                        big
                        onClick={handleLoginAccountGarena}
                        disable={loading}
                    />

                    {messageErrorLogin && <div className={cx('message')}>{messageErrorLogin}</div>}
                </div>
                <div className={cx('field')}>
                    <CusButton text="Tạo tài khoản mới" big secondary onClick={handleRegisterAccount} disable={loading} />
                </div>

                <div className={cx('agreement')}>
                    <a href="https://contentgarena-a.akamaihd.net/legal/tos/tos_vn.html" target="_blank" rel="noreferrer">
                        Điều Khoản Dịch Vụ
                    </a>
                    {' và '}
                    <a href="https://contentgarena-a.akamaihd.net/legal/pp/pp_vn.html" target="_blank" rel="noreferrer">
                        Chính Sách Bảo Mật
                    </a>
                </div>
            </div>
        </div>
    );
}

export default GarenaLogin;
